import { ColumnsType } from "antd/es/table";
import dayjs from "../../../../../../../configs/dayjs";
import { useMemo } from "react";
import { DATE_FORMAT } from "../../../../../../../lib/constants";
import { Row, Tooltip } from "antd";
import { MailOutlined, PrinterOutlined } from "@ant-design/icons";
import { useFilters } from "./useFilters";
import { useReceiverCol } from "../../../../../../Email/hooks/useReceiverCol";
import { useStatusLabel } from "../../../../../../Email/hooks/useStatusLabel";
import { TableActions } from "../components/TableActions";
import { TypeIcon } from "../../../../../../Email/components/TypeIcon";

export const useTableColumns = (
  setItemToOpen: React.Dispatch<
    React.SetStateAction<{
      id: string;
      type: 1 | 2 | 3;
    } | null>
  >,
  reloadData: () => void
) => {
  const { filters } = useFilters();

  const { getStatusLabel } = useStatusLabel();

  const { getReceiverCol } = useReceiverCol();

  const columns: ColumnsType<any> = useMemo(
    () => [
      {
        title: "Send Date",
        dataIndex: "date",
        key: "date",
        width: "15%",
        render: (value: string, record: any) => (
          <Row className="align-center">
            {dayjs(value).format(DATE_FORMAT)}
            <TypeIcon type={record.type} status={record.status} isRecurring={record.isRecurring} />
          </Row>
        )
      },
      {
        title: "Subject",
        dataIndex: "subject",
        key: "subject",
        width: "45%",
        ellipsis: true,
        render: (value: string, record: any) => {
          const { type } = record;

          return (
            <Row className="w-100">
              <Tooltip placement="top" title={type === 1 ? "Email" : "Letter"}>
                {type !== 2 ? <MailOutlined className="mr-3" /> : <PrinterOutlined className="mr-3" />}
              </Tooltip>
              <p className="my-0 elipsis">{value}</p>
            </Row>
          );
        }
      },
      {
        title: "Receiver",
        dataIndex: "receiverName",
        key: "receiverName",
        width: "33%",
        ellipsis: true,
        render: (_: string, record: any) => {
          const { email, error, status, type } = record;

          const statusLabel = getStatusLabel(email, error);

          const value: string = getReceiverCol(record, record.status === 5);

          return (
            <Row className="w-100 justify-space-between">
              <Row className="d-block receiver-name">
                <p className="my-0 text-md elipsis" title={value}>
                  {value}
                </p>
                <p className="my-0 text-sm title elipsis">{email}</p>
              </Row>
              {type === 1 && status !== 5 && statusLabel}
            </Row>
          );
        }
      },
      {
        key: "receiverName",
        width: "7%",
        filters,
        defaultFilteredValue: ["2", "3"],
        render: (record: any) => <TableActions record={record} setItemToOpen={setItemToOpen} reloadData={reloadData} />
      }
    ],
    [filters, getStatusLabel, getReceiverCol, setItemToOpen, reloadData]
  );

  return { columns };
};
